import { render, staticRenderFns } from "./myteam.vue?vue&type=template&id=c4664cbc"
import script from "./myteam.vue?vue&type=script&lang=js"
export * from "./myteam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports